import { render, staticRenderFns } from "./EssentialRegulatoryDocumentsReport.vue?vue&type=template&id=ecb58c2c&"
import script from "./EssentialRegulatoryDocumentsReport.vue?vue&type=script&lang=js&"
export * from "./EssentialRegulatoryDocumentsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports